import {View} from 'MWC';
import tpl from '../templates/Tabs.jsx';
import React from 'react';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            proposalAtStart: true,
            proposalAtEnd: false
        };

        this.swiperRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tab !== this.props.tab) {
            this.scrollToActiveTab();
            this.syncProposalSwiperState();
        }
    }

    componentWillUnmount() {
        if (this.swiperCleanup) this.swiperCleanup();
    }

    getSwiper = () => {
        if (!this.swiperRef.current) return null;
        return this.swiperRef.current.swiper || null;
    };

    syncProposalSwiperState = () => {
        const swiper = this.getSwiper();
        if (!swiper) return;

        const update = () => {
            if (!swiper.slides || !swiper.slides.length) return;

            this.setState({
                proposalAtStart: swiper.isBeginning,
                proposalAtEnd: swiper.isEnd
            });

            swiper.allowTouchMove = !(swiper.isBeginning && swiper.isEnd);
        };

        ['setTranslate', 'slideChange', 'touchEnd', 'resize'].forEach(event =>
            swiper.on(event, update)
        );

        setTimeout(() => {
            swiper.update();
            update();
        }, 0);

        return () => {
            ['setTranslate', 'slideChange', 'touchEnd', 'resize'].forEach(event =>
                swiper.off(event, update)
            );
        };
    };

    toggleTab = tab => {
        if (this.props.toggle) {
            this.props.toggle(tab);
        }

        if (this.getSwiper()) {
            this.scrollToActiveTab();
            this.syncProposalSwiperState();
        }
    };

    slidePrev = () => {
        const swiper = this.getSwiper();
        if (swiper) swiper.slidePrev();
    };

    slideNext = () => {
        const swiper = this.getSwiper();
        if (swiper) swiper.slideNext();
    };

    scrollToActiveTab = (animated = true) => {
        const swiper = this.getSwiper();
        if (!swiper) return;

        const {tabs, tab} = this.props;
        if (!tabs || !tab) return;

        const index = tabs.findIndex(item => item.tab === tab);
        if (index > -1) swiper.slideTo(index, animated ? 500 : 0);
    };

    initSlider = swiper => {
        if (!swiper) return;

        const ref = this.swiperRef.current;
        if (!ref) return;

        ref.swiper = swiper;
        this.swiperCleanup = this.syncProposalSwiperState();
        this.scrollToActiveTab(false);
    };
}
